// Gets authentication for Forge
export const forgeAuth = () => {
    // return fetch(`http://localhost:8080/api/forge/auth`, {
    return fetch(`https://zoeked.com/api/forge/auth`, {        
        method: "POST",
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
            return err.json();
        })
};
